import { useState } from 'react';
import { useSession } from './useSession.js';
import { SetupView } from './views/SetupView.js';
import { CheckInView } from './views/CheckInView.js';
import { LiveView } from './views/LiveView.js';
import { ReviewView } from './views/ReviewView.js';

const TABS = ['Setup', 'Check-in', 'Live control', 'Review'] as const;
type Tab = (typeof TABS)[number];

export function SimApp() {
  const { session } = useSession();
  const [tab, setTab] = useState<Tab>('Setup');
  const rec = session.engine?.record ?? null;

  return (
    <div>
      <h1>Rotation Controller</h1>
      <p className="muted">
        {session.adapterKind === 'zoom' ? 'Inside Zoom' : 'Simulator'} · {session.mode === 'backend' ? 'backend connected' : 'local mode'} ·{' '}
        {session.context ? `role ${session.context.role}, ${session.context.location} session` : 'no meeting context'}
        {rec ? ` · ${rec.title} · state ${rec.state}` : ''}
      </p>
      {session.notice && <div className="banner banner-info">{session.notice}</div>}
      {session.error && (
        <div className="banner banner-error" role="alert">
          {session.error}
        </div>
      )}
      {session.mode === 'backend' && rec && !session.hasControl && (
        <div className="banner banner-warn">
          Another controller holds control of this event{session.leaseHolder ? ` (${session.leaseHolder})` : ''}.{' '}
          <button className="secondary" onClick={() => void session.takeControl()}>
            Take control
          </button>
        </div>
      )}
      <nav className="tabs" role="tablist" aria-label="Controller views">
        {TABS.map((t) => (
          <button key={t} role="tab" aria-selected={tab === t} onClick={() => setTab(t)}>
            {t}
          </button>
        ))}
      </nav>
      {tab === 'Setup' && <SetupView session={session} />}
      {tab === 'Check-in' && <CheckInView session={session} />}
      {tab === 'Live control' && <LiveView session={session} />}
      {tab === 'Review' && <ReviewView session={session} />}
    </div>
  );
}
